import React from 'react';
import { css } from 'emotion';

const styles = {
  title: {
    color: '#484b4c',
    fontSize: '1.5rem',
    margin: '1rem 0 1rem 0',
    fontWeight: 'normal'
  },
  center: {
    textAlign: 'center'
  },
  button: {
    padding: '10px 20px',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.9
    }
  },
  optimizeButton: {
    backgroundColor: '#429853',
    '&:hover': {
      backgroundColor: '#3a8748'
    }
  },
  saveButton: {
    backgroundColor: '#2c5282',
    '&:hover': {
      backgroundColor: '#2a4365'
    }
  },
  orsButton: {
    backgroundColor: '#6b46c1',
    '&:hover': {
      backgroundColor: '#553c9a'
    }
  },
  disabled: {
    backgroundColor: '#ccc',
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: '#ccc'
    }
  },
  error: {
    color: 'red',
    marginTop: '10px'
  },
  waitPopup: {
    position: 'fixed',
    right: '20px',
    bottom: '20px',
    background: 'rgba(0,0,0,0.85)',
    color: '#fff',
    padding: '12px 14px',
    borderRadius: '8px',
    fontSize: '0.95rem',
    zIndex: 9999
  }
};

const AutoDeliveriesHeader = ({ 
  isLoading, 
  optimizedRoutes, 
  error, 
  onSaveAll,
  onOptimizeSchedules,
  waitRemaining,
  waitScope
}) => {
  return (
    <div className={css(styles.center)}>
      <h2 className={css(styles.title)}>{'Livraisons et Récupérations'} non attribuées</h2>
      <div className={css({
        display: 'flex',
        gap: '1rem',
        justifyContent: 'center',
        marginBottom: '1rem'
      })}>
        <button 
          onClick={onOptimizeSchedules}
          disabled={isLoading}
          className={css(styles.button, styles.orsButton, isLoading && styles.disabled)}
        >
          {isLoading ? 'Automatisation en cours...' : 'Automatiser les itinéraires'}
        </button>
        {optimizedRoutes.length > 0 && (
          <button 
            onClick={onSaveAll}
            disabled={isLoading}
            className={css(styles.button, styles.saveButton, isLoading && styles.disabled)}
          >
            {isLoading ? 'Sauvegarde en cours...' : 'Sauvegarder tous les itinéraires'}
          </button>
        )}
      </div>
      {error && (
        <div className={css(styles.error)}>
          {error}
        </div>
      )}
      {typeof waitRemaining === 'number' && waitRemaining > 0 && (
        <div className={css(styles.waitPopup)}>
          Limite OpenRouteService atteinte ({waitScope || 'minute'}) — nouvel essai dans {Math.ceil(waitRemaining/1000)}s
        </div>
      )}
    </div>
  );
};

export default AutoDeliveriesHeader; 